var render = function render(){var _vm=this,_c=_vm._self._c;return _c('uploadList',{attrs:{"uploadType":"img","uploadTitle":"点击上传本地图片","btnTitle":"预览","accept":['.jpg','.png','.jpeg'],"listW":"180px","listH":"290px","rowNum":5,"limit":14,"uploadSize":"5mb"}})
}
var staticRenderFns = []

export { render, staticRenderFns }